// @flow
import React from 'react';
import NotificationSettingsRowTemplate from './NotificationSettingsRowTemplate';

const NotificationSettingsHeader = (props: {}) => {
    const headerStyles = {
        fontWeight: '700'
    };

    let emailColumn = null;
    if (props.includeEmail) {
        emailColumn = <div>Email</div>;
    }

    let pushColumn = null;
    if (props.includePush) {
        pushColumn = <div>Push</div>;
    }

    return (
        <NotificationSettingsRowTemplate
            firstColumn={<div>Notification</div>}
            secondColumn={pushColumn}
            thirdColumn={emailColumn}
            rowStyles={headerStyles}
        />
    );
};

export default NotificationSettingsHeader;
